import {
  Box,
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { getPartitionsArrangementByTrayThunk } from "store/reducers/refill/refillSlice";
import RefillDialog from "pages/refill/RefillDialog";
import RemoveDialog from "pages/refill/RemoveDialog";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

const PartitionRefill = ({ tray }) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [currentItem, setCurrentItem] = React.useState(null);

  const { items } = useSelector((state) => state.refill);

  useEffect(() => {
    dispatch(getPartitionsArrangementByTrayThunk(tray.id));
  }, [tray]);

  const handleRefillClick = (item) => {
    setCurrentItem(item);
    setOpenRefillDialog(true);
  };

  const [openRefillDialog, setOpenRefillDialog] = React.useState(false);
  const handleRefillDialogClose = () => {
    setOpenRefillDialog(false);
  };

  const handleRemoveClick = (item) => {
    setCurrentItem(item);
    setOpenRemoveDialog(true);
  };

  const [openRemoveDialog, setOpenRemoveDialog] = React.useState(false);
  const handleRemoveDialogClose = () => {
    setOpenRemoveDialog(false);
  };

  const { success } = useSelector((state) => state.refill);

  // useEffect(() => {
  //   if (
  //     (success?.assign_product && success?.tray === tray.id) ||
  //     (success?.remove_product && success?.tray === tray.id)
  //   ) {
  //     dispatch(getPartitionsArrangementByTrayThunk(tray.id));
  //   }
  // }, [success, tray.id]);

  useEffect(() => {
    if (success?.assign_product || success?.remove_product) {
      dispatch(getPartitionsArrangementByTrayThunk(tray.id));
    }
  }, [success, tray.id]);

  const [openRows, setOpenRows] = React.useState(false);

  return (
    <Box>
      {items[tray.id]?.length > 0 && (
        <Box
          sx={{ backgroundColor: "#e7ebf0", borderRadius: 1, flex: 1, mt: 1 }}
          padding={0.5}
        >
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: 140 }} align="center">
                    {isSmallScreen ? "Number" : "Partition number"}
                  </TableCell>
                  <TableCell align="center" sx={{ minWidth: 160 }}>
                    {isSmallScreen ? "Desc" : "Description"}
                  </TableCell>
                  <TableCell align="center" sx={{ minWidth: 160 }}>
                    {isSmallScreen ? "Product" : "Product name"}
                  </TableCell>
                  <TableCell align="center">Max count</TableCell>
                  <TableCell align="center">Current count</TableCell>
                  <TableCell sx={{ width: 80 }}>&nbsp;</TableCell>
                  <TableCell sx={{ width: 80 }}>
                    &nbsp;
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items[tray.id]?.map((partition) => (
                  <TableRow
                    key={partition.id}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell component="th" scope="row" align="center">
                      {partition.number}
                    </TableCell>
                    <TableCell align="center">
                      {partition.desc?.length > 0 ? partition.desc : "-"}
                    </TableCell>
                    <TableCell align="center">
                      {partition.arrangement?.current_product_name}
                    </TableCell>
                    <TableCell align="center">{partition.max_count}</TableCell>
                    <TableCell align="center">
                      {partition.current_count}
                    </TableCell>

                    <TableCell align="center">
                      <Button
                        color="info"
                        variant="outlined"
                        size="small"
                        onClick={() => handleRefillClick(partition)}
                      >
                        Refill
                      </Button>
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={() => {
                          handleRemoveClick(partition);
                        }}
                      >
                        Remove
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      <RefillDialog
        open={openRefillDialog}
        handleClose={handleRefillDialogClose}
        tray_id={tray.id}
        partition={currentItem}
        setCurrentItem={setCurrentItem}
      />
      <RemoveDialog
        open={openRemoveDialog}
        handleClose={handleRemoveDialogClose}
        partition={currentItem}
        tray_id={tray.id}
        setCurrentItem={setCurrentItem}
      />
    </Box>
  );
};

export default PartitionRefill;
